module.exports = __webpack_public_path__ + "img/check-icon.f648effe.svg";